import React from 'react';
import '../style/toba.css'
import { Heading, Alert, Link, Button, List, HorizontalRule, FormGroup } from 'arag-ui-lib';
import { DOWNLOAD, ERROR, HEADING_2, HEADING_3, LEFT, TERTIARY } from '../helpers/constants';
import CONTENT_STRINGS from '../helpers/contentStrings';
import { FORM_GROUP_VARIANTS } from '../helpers/formGroupVariants';

const SolicitorHomePage = (props) => {
    
    const {
        articles,
        push,
        requestGetArticleAttachment,
        failedToReceivePendingTobaMsg,
    } = props;
    return (
        <div className="row">
            <div className="col-sm-12">
                {
                    (failedToReceivePendingTobaMsg)
                    ?
                        <div className="row">
                            <div className="col-sm-12">
                                <form className="form-horizontal">
                                    <Alert
                                        variant={ERROR}
                                        title={failedToReceivePendingTobaMsg}
                                    />
                                </form>
                            </div>
                        </div>
                    :
                        null
                }
                <div className="row">
                    <div className="col-sm-12">
                        <Heading variant={HEADING_2} title={CONTENT_STRINGS.NEWS_AND_ARTICLES} headingTestId={'solicitor-home-articles-header'}/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        {
                            articles.map((article, index) => {
                                if (index <= 2) {
                                    return (
                                        <div key={index}>
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <Heading variant={HEADING_3} title={article.title} headingTestId={`solicitor-home-articles-${index}-title`}/>
                                                </div>
                                            </div>
                                            <FormGroup
                                                labelSize={'col-sm-12'}
                                                inputSize={'col-sm-12'}
                                                label={<div dangerouslySetInnerHTML={{__html: article.body}}></div>}
                                                variant={FORM_GROUP_VARIANTS.PLAIN}
                                                inputProps={{
                                                    name: 'articleDate' + index,
                                                }}
                                                formGroupTestId={`solicitor-home-articles-${index}-content`}
                                            />
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <List
                                                        id={'solicitorArticlesList-modal-attachments'}
                                                        listTestId={'solicitor-home-articles'}
                                                        items={
                                                            article.attatchmentDtos.map((attachment, index) => ({
                                                                content: 
                                                                <div className='col-sm-12' style={{display: 'flex', flexDirection: 'row', gap: '10px'}} key={index}>
                                                                    <Button
                                                                        variant={DOWNLOAD}
                                                                        onClick={() => {
                                                                            requestGetArticleAttachment({ articleId: article.id, attachmentId: attachment.id })
                                                                        }}
                                                                        label={CONTENT_STRINGS.DOWNLOAD}
                                                                        buttonTestId={`solicitor-home-articles-${index}-download`}
                                                                    />
                                                                    <FormGroup
                                                                        labelSize={''}
                                                                        inputSize={'col-sm-12'}
                                                                        label={''}
                                                                        variant={FORM_GROUP_VARIANTS.PLAIN}
                                                                        inputProps={{
                                                                            name: 'attachmentDescription' + index,
                                                                            label: attachment.name,
                                                                        }}
                                                                        formGroupTestId={`solicitor-home-articles-${index}-attachment-name`}
                                                                    />
                                                                </div>
                                                            })
                                                        )}
                                                    />
                                                </div>
                                            </div>
                                            <HorizontalRule />
                                        </div>
                                    )
                                }
                                else 
                                    return null;
                            })
                        }
                        <Link 
                            onClick={() => push('/articles')}
                            label={CONTENT_STRINGS.VIEW_ALL_ARTICLES}
                            arrowDirection={LEFT}
                            variant={TERTIARY}
                            linkTestId={'solicitor-home-view-all-articles'}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
};

export default SolicitorHomePage;